import { Button } from "@/components/ui/button";

/** Shared not-found layout, also rendered by the server for retired URLs. */
export function MissingPage({ gone = false, title, body, homeLabel }: {
  gone?: boolean; title?: string; body?: string; homeLabel?: string;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <p className="font-serif text-7xl text-ink" aria-hidden>{gone ? "410" : "404"}</p>
        <h1 className="mt-4 font-serif italic text-xl">{gone ? "Bu yazı kaldırıldı." : title}</h1>
        {!gone && <p className="mt-2 text-sm text-muted-foreground">{body}</p>}
        <div className="mt-6">
          <Button asChild><a href={gone ? "/yazilar" : "/"}>{gone ? "Yazılara dön" : homeLabel}</a></Button>
        </div>
      </div>
    </div>
  );
}